<template>
    <div class="line-item"> 
        <div class="heading ml-2" style="display:flex;" @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE');">
            <!-- <v-btn class="mx-0" icon @click.prevent="$store.myActions.UI_TOGGLE_FLEET_MAP_VISIBILITY({fleId:fleet.FLE_ID,uiid:detailUiid})" :title="$t(mapVisibility[mission.misId]?'Pilot.MissionDrawer.HideMissionTooltip':'Pilot.MissionDrawer.ShowMissionTooltip')"><v-icon>{{mapVisibility[mission.misId]?'mdi-eye':'mdi-eye-off'}}</v-icon></v-btn> -->                         
             <v-icon class="!text-black">{{ fleetIco }}</v-icon>
             <fleet-state :fleet="fleet" /> 
             <v-btn :to="accesPilotReachDetail.enable?{name:'FleetDetail',params:{fleetid:fleet.FLE_ID}}:null" class="missionbtn mx-0 pr-2" :class="{testMission:fleet.isTestFleet}" flat :title="$t(detailVisibility[fleet.FLE_ID]?'Pilot.MissionDrawer.HideMoreMissionInfosTooltip':'Pilot.MissionDrawer.ShowMoreMissionInfosTooltip')" >
                {{fleet.FLE_LIBELLE}}
             </v-btn>             
        </div>        
    </div>
</template>
<script setup lang="ts">
import { SecurityItemsKeys } from '@/enum/SecurityItems';
import { AloDbFleet, isAloDbFleetCoverage, isAloDbFleetFormation } from '@/models/alodb/AloDbFleet'
 
  import FleetState from './FleetState.vue'
import store from '@/store';
import { computed } from 'vue';

const props = defineProps({
  fleet: {
    type: AloDbFleet,
    required: true
  }
})


const fleetIco = computed(() => {
    return isAloDbFleetCoverage(props.fleet)  ? 'mdi-select-group' 
          :isAloDbFleetFormation(props.fleet) ? 'mdi-vector-circle' 
                                              : 'mdi-multicast'
  })




 const accesPilotReachDetail = computed(() => {
    return  props.fleet.security[SecurityItemsKeys.PILOT_REACH_DETAIL]
}) 

const detailVisibility = computed(() => {
    return {}
})

</script>